import { Component, h, Host, Prop, State } from '@stencil/core';
import { JSX } from '@stencil/core/internal';

@Component({
  tag: 'lk-anchor-group'
})
export class AnchorGroup {

    @State() articlesAndAsides: HTMLElement[] = []

    @Prop() tagSelector: string = "h2"

    makeSvgArrow(){
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18.348" height="18.375" viewBox="0 0 18.348 18.375">
                <g data-name="arrow-right copy" transform="translate(17.674 0.188) rotate(90)">
                <path d="M0,.386H16.875" transform="translate(0.563 8.114)" fill="none" stroke="#3c78b4"
                    stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                <path data-name="Path" d="M0,16.227,7.875,8.114,0,0" transform="translate(9.563 0.386)" fill="none"
                    stroke="#3c78b4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                </g>
            </svg>
        )
    }

    componentWillLoad() {    
        const articleHeaders: NodeListOf<HTMLElement> = document.querySelectorAll(`article ${this.tagSelector}`);
        const asideHeaders: NodeListOf<HTMLElement> = document.querySelectorAll(`aside ${this.tagSelector}`);

        if(articleHeaders.length > 0 || asideHeaders.length > 0){
            this.articlesAndAsides = [...articleHeaders, ...asideHeaders]
        }
    }

    parseATagLink(item: HTMLElement): string {
        const taglink = item?.id || item.querySelector('a')?.id;
        if (taglink != null) {
            return `#${taglink}`;
        }
        return ''
    }

    createListItems(item: HTMLElement): JSX.Element {
        const anchorTarget = (item?.id ? item : null) || item.querySelector('a[id]');
        if(anchorTarget == null || 
            (anchorTarget.nodeName != 'A' && !anchorTarget.id)
        ) {
            return;
        }
        
        const isAsideChild = (item.parentNode as HTMLElement).tagName == 'ASIDE'
        const tagLink = this.parseATagLink(item) as string
        const title = item.textContent !== '' ? item.textContent : item.querySelector(tagLink).innerHTML

        return (
            <li class={`anchor-list__item ${isAsideChild ? 'visible-on-tablet' : ''}`}>
                <a href={tagLink}>
                    {this.makeSvgArrow()}
                    <span>{title}</span>
                </a>
            </li>
        )
    }

    render() {
        return (
            <Host class="lk-anchor-group">
                <nav aria-label="innholdsfortegnelse">
                    <ul class="anchor-list">
                        {this.articlesAndAsides.map(item => this.createListItems(item))}
                    </ul>
                </nav>
            </Host>
        );
    }
}
